export default "__VITE_ASSET__YxSvPxtb__"